<template>
    <div v-if="display">
        <div class="container header-margin">
            
            <div class="text-center p-2 text-color text-area">
                <h2 class="main_title">{{ $t('auth.signupTitleForceclub') }}</h2>
            </div>

            <div v-if="errors_token.timeOverToken">
                <!-- トークンデータ24時間超過 -->
                <div class="show-check-email-message" v-html="$t('auth.registrationTimeOverTokenForceclubText')"></div><br />
                <div class="text-center">
                    <div class="pb-4 ">
                        <a class="btn btn-primary text-center-btn" href="https://www.force-club.com/login" role="button">{{$t('auth.changeEmail.buttom') }}</a>
                    </div>
                </div>
            </div>
            <div v-if="errors_token.notLatestToken">
                <!-- 最新ではないトークンデータ -->
                <div class="show-check-email-message" v-html="$t('auth.notLatestTokenText')"></div><br />
                <div class="text-center">
                    <div class="pb-4 ">
                        <a class="btn btn-primary text-center-btn" href="https://www.force-club.com/login" role="button">{{$t('auth.changeEmail.buttom') }}</a>
                    </div>
                </div>
            </div>
            <div v-if="errors_token.notExistToken">
                <!-- トークンデータが存在しない -->
                <div class="text-center p-2">
                    {{ $t('auth.notExistTokenText') }}
                </div><br />
                <div class="text-center">
                    <div class="pb-4 ">
                        <a class="btn btn-primary text-center-btn" href="https://www.force-club.com/login" role="button">{{$t('auth.changeEmail.buttom') }}</a>
                    </div>
                </div>
            </div>

            <div v-if="success === true">
                <div class="tab-content p-2" >
                    <div class="row no-gutters text-center navigation">
                        <div id="box1" class="col-md-3 col-sm-3 col-xs-5 box-area non-active-color-box"><p class="text-box">{{ $t('auth.navigationForceclub.title1') }}</p></div>
                        <div id="box2" class="col-md-3 col-sm-3 col-xs-5 box-area non-active-color-box"><p class="text-box">{{ $t('auth.navigationForceclub.title2') }}</p></div>
                        <div id="box3" class="col-md-3 col-sm-3 col-xs-5 box-area active-color-box"><p class="text-box">{{ $t('auth.navigationForceclub.title3') }}</p></div>
                        <div id="box4" class="col-md-3 col-sm-3 col-xs-5 box-area non-active-color-box"><p class="text-box">{{ $t('auth.navigationForceclub.title4') }}</p></div>
                    </div>

                    <div class="mx-auto" >
                        <div class="text-center p-2">
                            <h3 class="text-color sub_title">{{ $t('auth.userProfileConfirm.titleAube') }}</h3>
                        </div>

                        <form @submit.prevent="handleOnSubmit">
                            <div class="wrap-value">
                            
                                <div>
                                    <label style="margin-bottom:10px;">{{ $t('auth.userProfileConfirm.textAube') }}</label>
                                </div>

                                <div class="form-group row">
                                    <label  for="emailAube" class="col-sm-3 col-lg-2 col-form-label pre">{{ $t('account.emailAube') }}</label>
                                    <div class="col-sm-8 col-form-value">
                                        {{formData.account ? formData.account : '-'}}
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label  for="first_name" class="col-sm-3 col-lg-2 col-form-label pre">{{ $t('account.edit.name.first') }}</label>
                                    <div class="col-sm-8 col-form-value">
                                        {{formData.first_name ? formData.first_name : '-'}}
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label  for="last_name" class="col-sm-3 col-lg-2 col-form-label pre">{{ $t('account.edit.name.last') }}</label>
                                    <div class="col-sm-8 col-form-value">
                                        {{formData.last_name ? formData.last_name : '-'}}
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label  for="password_conversion" class="col-sm-3 col-lg-2 col-form-label pre">{{ $t('account.edit.password') }}</label>
                                    <div class="col-sm-8 col-form-value">
                                        {{formData.password_conversion ? formData.password_conversion : '-'}}
                                    </div>
                                </div>


                                <div class="form-group row">
                                    <label  for="birth_date" class="col-sm-3 col-lg-2 col-form-label pre">{{ $t('account.edit.birthDate') }}</label>
                                    <div class="col-sm-8 col-form-value">
                                        {{formData.birth_date ? formData.birth_date : '-'}}
                                    </div>
                                </div>
                                
                            </div>
                        
                            <div class="text-center">
                                <table class="table text-center">
                                    <tbody>
                                        <tr>
                                            <th class="back_btn">
                                                <button type="button"  class="btn btn-outline-primary" @click="back">{{ $t('auth.userProfileConfirm.backBtn') }}</button>
                                            </th>
                                            <th class="submit_btn" style="margin-left: 29px;">
                                                <button type="button" @click="handleOnSubmit" class="btn btn-primary mr-2" :disabled="submitBtnDisabled()">{{ $t('auth.userProfileConfirm.finishUpdateBtn') }}</button>
                                            </th>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import UserService from '../../../services/UserService';
    import languageService from "../../../services/LanguageService";
    import RecaptchaMixin from '../../../utils/RecaptchaMixin';

    export default {
        name: 'registration-module',
        mixins: [RecaptchaMixin],

        data() {
            return {
                errors: this.getdefaultFields(),
                formData: this.getdefaultFields(),
                display: false,
            }
        },

        created() {
            this.getConfirmData();
            this.token = this.$route.query.token;
            this.fetchUserData(this.token);
        },
        mounted() {
            this.maxHeight();
        },

        methods: {
            back: function(event){
            this.$router.push({
                path: '/registration-forceclub/continue',
                query: {
                        token: this.token
                    }
                })
            },
            getdefaultFields() {
                return {
                    first_name: '',
                    last_name: '',
                    birth_date: '',
                    password: '',
                    password_confirmation: '',
                    timeOverToken: '',
                    notLatestToken: '',
                    notExistToken: '',
                    success: false,
                };
            },
            submitBtnDisabled() {
                if (this.formData.first_name== '' ||
                this.formData.last_name== '' ||
                this.formData.birth_date== '' ||
                this.formData.password== '') {
                    return true
                } else {
                    return false
                }
            },
            async handleOnSubmit() {
                this.errors = this.getdefaultFields();
                let languageCode = await languageService.getCurrentLanguageCode();
                const recaptchaToken = await this.recaptchaGetKey();
                try {
                    const result = await UserService.updateRegistrationForceClub({
                        token: this.formData.token,
                        languageCode: languageCode,
                        ...this.formData,
                        recaptchaToken
                    });
                    this.$router.push({
                        path: '/registration-forceclub/complete',
                        query: {
                            token: this.formData.token
                        }
                    })
                } catch (err) {
                    if (err.response.data.errors) {
                        err.response.data.errors.forEach(errItem => {
                            if (errItem.field) {
                                this.errors_token[errItem.field] = errItem.field;
                                this.$router.push('/registration-forceclub/error?message=' + errItem.field);
                            }
                        })
                    }
                }
            },

            async getConfirmData() {
                if(sessionStorage.formData){
                    this.formData = JSON.parse(sessionStorage.formData);
                }
            },
            async fetchUserData(token) {
                this.errors_token = this.getdefaultFields();

                if(token == undefined && sessionStorage.formData){
                    token = JSON.parse(sessionStorage.formData).token;
                }
                try {
                    const result = await UserService.getUserConfirmDataByToken(token);
                    if(result.data.member_type_id ==2100 || 
                        result.data.member_type_id == 2200
                    ){
                        this.$router.push('/');
                    }else{
                        this.display = true
                        this.maxHeight();
                    }
                    this.success = true
                } catch (err) {
                    this.display = true
                    if (err.response.data.errors) {
                        err.response.data.errors.forEach(errItem => {
                            if (errItem.field) {
                                this.errors_token[errItem.field] = errItem.field;
                            }
                        })
                    }
                }
            },
            async maxHeight() {
                setTimeout(() => {
                    let box1 = document.getElementById('box1').clientHeight
                    let box2 = document.getElementById('box2').clientHeight
                    let box3 = document.getElementById('box3').clientHeight
                    let box4 = document.getElementById('box4').clientHeight
                    let maxHeight = Math.max(box1,box2,box3,box4);
                    document.getElementById('box1').style.height = maxHeight+'px'
                    document.getElementById('box2').style.height = maxHeight+'px'
                    document.getElementById('box3').style.height = maxHeight+'px'
                    document.getElementById('box4').style.height = maxHeight+'px'
                 }, 1000);
            },
        }

    }
</script>

<style scoped>
    .main_title{
        margin-bottom:15px;
    }
    .sub_title{
        margin-bottom:15px;
    }
    .back_btn{
        text-align:right;
        font-weight:normal;
        width: 505px;
    }
    .submit_btn {
        text-align:left;
        font-weight:normal;
        width: 500px;
        padding-right: 0px;
    }
    .table th, .table th {
        border-top: 0px solid #dee2e6;
    }
    .table{
        position:relative;
    }
    .tos.form-control:disabled {
        background-color: white;
    }
    .pre {
        white-space: pre-wrap;
    }
    .active-color-box{
        background: #3CB371;
        border-color:#3CB371;
    }
    .non-active-color-box{
        background: #bdbebd; 
    }
    .text{
        font-size: 25px;
    }
    .text-area{
        padding-bottom: 20px;
    }
    .box-area {
        padding: 0.5em 0em;
        width:50%;
        color: #FFF;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    #box2,#box3,#box4{
        outline: 1px solid #FFF;
    }
    .box-area p {
        margin-top: 2px;
        margin-bottom: 2px;
        padding-top: 1px;
    }

    .header-margin{
        top:250px;
    }
    .navigation{
        padding-top:15px;
        padding-bottom:40px;
    }

    .text-color{
        color: #3CB371;
    }
   /* ボタンのスタイル指定 */
    .btn-primary{
        width: 115px;
        background: #3CB371!important;
        border-color:#3CB371!important;
        color: #FFF;
    }
    .btn-primary:hover {
        color: #fff !important;
        background-color: #339960 !important;
        border-color: #3CB371 !important;
    }
    .btn-primary:focus, 
    .btn-primary.focus {
        box-shadow: 0 0 0 0.2rem rgba(16,230,123,0.7);
    }
    .btn-primary:not(:disabled):not(.disabled):active:focus, 
    .btn-primary:not(:disabled):not(.disabled).active:focus, 
    .show > .btn-primary.dropdown-toggle:focus {
        box-shadow: 0 0 0 0.2rem rgba(16,230,123,0.7);
    }
    .wrap-value{
        margin-left: 35px;
        margin-bottom: 10px;
    }

    .wrap-values{
        width:500px;
        margin-left: 35px;
    }

    .col-sm-8{
        padding-top:8px;
    }

    .btn-outline-primary:not(:disabled):not(.disabled).active:focus, 
    .show > .btn-outline-primary.dropdown-toggle:focus {
        box-shadow: 0 0 0 0.2rem rgb(216 217 219 / 50%);
    }
    .btn-outline-primary:not(:disabled):not(.disabled):active:focus, 
    .btn-outline-primary:not(:disabled):not(.disabled).active:focus, 
    .show > .btn-outline-primary.dropdown-toggle:focus {
        box-shadow: 0 0 0 0.2rem rgb(216 217 219 / 50%);
    }
    .btn-outline-primary:not(:disabled):not(.disabled):active, 
    .btn-outline-primary:not(:disabled):not(.disabled).active, .show > 
    .btn-outline-primary.dropdown-toggle {
        color: #212529;
        background-color: #C4C4CC!important;
        border-color: #E2E6EA;
    }
    .btn-outline-primary:focus, .btn-outline-primary.focus {
        box-shadow: 0 0 0 0.2rem rgb(216 217 219 / 50%);
    }
    .btn-outline-primary {
        width: 115px;
        color: #212529;
        background-color: #E2E6EA;
        border-color:  #E2E6EA;
    }
    .btn-outline-primary:hover {
        color: #212529;
        background-color: #c4c4cc !important;
        border-color: #c4c4cc !important;
    }
    
    .form-control:focus {
        border-color: #3CB371;
        box-shadow: 0 0 0 0.2rem rgba(16,230,123,0.7);
    }

    /*スマホ用css*/

    @media screen and (max-width: 479px) {
   
        .box-area[data-v-40212d93] {
            height: 90px;
        }
        .wrap-value{
            margin-left: 0px;
        }
        .wrap-values{
            width:500px;
            margin-left: 0px;
        }
        .col-form-label{
            padding-bottom: 0px;
        }
        .col-form-value{
            padding-top: 0px;
        }
        .header-margin{
            padding-left: 0px;
            padding-right: 0px;
        }
        .col-sm-8{
            padding-top:0px;
        }
        .main_title{
            font-size: 1.575rem;
            margin-bottom: 0px;
        }
        .sub_title{
            font-size: 1.3rem;
            margin-bottom: 10px;
        }
        .navigation{
            padding-top: 0px;
            padding-bottom:15px;
        }

    }
    .show-check-email-message {
        text-align: center;
    }
    .show-check-email-message >>> br {
        display: inline;
    }
    @media screen and (max-width: 767px) {
        .show-check-email-message {
            text-align: left;
        }
        .show-check-email-message >>> br {
            display: none;
        }
    }
</style>